import React from 'react';
import TenToTheTopScorecard from './TenToTheTopScorecard';
import './App.css';

function App() {
  return (
    <div className="App">
      <TenToTheTopScorecard />
    </div>
  );
}

export default App;
